import React from "react";
import GalleryHeroArea from "./GalleryHeroArea";
import GalleryArea from "./GalleryArea";

const Gallery = () => {
  return (
    <>
      <GalleryHeroArea />
      <GalleryArea />
    </>
  );
};

export default Gallery;
